var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 30,
    viewBox: "0 0 14 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3242 22.4895C12.8602 24.1721 13.3969 25.8553 13.9329 27.5379C14.164 28.2619 13.7798 29.0145 13.0173 29.3315C9.14334 30.943 4.60613 29.5595 2.78964 26.0594C-0.929882 18.8922 -0.929882 11.1078 2.78965 3.94059C4.60613 0.440541 9.14334 -0.943005 13.0173 0.668545C13.7798 0.985483 14.164 1.73814 13.9336 2.46274C13.3969 4.14472 12.8602 5.82789 12.3242 7.51047C12.0725 8.29953 11.3267 8.83552 10.4131 8.88327C9.21592 8.94654 8.01869 9.00981 6.82213 9.07248C5.09621 12.7755 5.0962 17.2245 6.82213 20.9275C8.01869 20.9902 9.21592 21.0535 10.4131 21.1167C11.3274 21.1651 12.0725 21.7005 12.3242 22.4895Z",
    fill: "#83ba26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGreen);
export default __webpack_public_path__ + "static/media/phone_green.ed8ac8188ec7cfab28569d47d294550e.svg";
export { ForwardRef as ReactComponent };